module.exports = __webpack_public_path__ + "static/media/mars.cf3eada4.svg";